export default {"src":"/_next/static/media/telegram.feb7d7c2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};